import { render, staticRenderFns } from "./ParticleDemo.vue?vue&type=template&id=16e5547e&"
import script from "./ParticleDemo.vue?vue&type=script&lang=js&"
export * from "./ParticleDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports